import React, { useState, useEffect } from "react";
import TopHeader from "../../../Component/Header/TopHeader";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";

import TableRow from "@mui/material/TableRow";
import {
  usePaginationchapterRewardMutation, useLazyEnableDisablechapterRewardQuery
} from "../../../app/services/chapterRewardsService";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ReactPaginate from "react-paginate";
import Spinner from "../../../Component/spinner/spinner";
import { Container, Button, IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectCurrentScope } from "../../../app/auth/authSlice";


//table head for chapterReward
function EnhancedCategoryTableHead() {
  const headCells = [
    {
      id: "rewards",
      numeric: false,
      disablePadding: false,
      label: "Rewards"
    },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    // {
    //   id: "subCategoryname",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Sub Category Name"
    // },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

const ChapterRewardTable = () => {

  const [loading, setLoading] = useState(true);
  const [page, setPage] = React.useState(0); //state for set page
  const [rowsPerPage, setRowsPerPage] = React.useState(5); //state for item per page
  const [getAllPaginationchapterReward] = usePaginationchapterRewardMutation(); //API call of Get all
  const [EnableDistablechapterReward] = useLazyEnableDisablechapterRewardQuery()
  const [totalPage, setTotalPage] = useState(0);
  const [allChapterReward, setAllChapterReward] = useState([]);
  const memberScope = useSelector(selectCurrentScope);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState("");
  // const [openModal, setOpenModal] = useState(false);
  // const [selectRewards,setSelectRewards]=useState()
  // const [deleteRewards] = useDeletechapterRewardMutation()




  //   const handleClose = () => setOpen(false);
  //calling event data
  useEffect(() => {
    setRowsPerPage(5);
    const data = { type: 0 };
    fetchData(data);
    // Fetch data on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, itemsPerPage]); // Update useEffect dependencies

  // const handleClose = () => {
  //   setOpenModal(false)
  // }
  //   const handleDelete=()=>{
  //     deleteRewards(selectRewards).then((res)=>{
  //       toast.error(res?.data?.message)
  //       setOpenModal(false)
  //       fetchData()
  //     })
  //  }
  //  const handleOpen=(id)=>{
  // setOpenModal(true)
  // setSelectRewards(id)
  //  }

  //getAllPendingEventList
  const fetchData = (datas) => {
    var data = {
      page: page + 1,
      itemsPerPage: itemsPerPage,
    };
    getAllPaginationchapterReward(data)
      .then((res) => {
        setLoading(false);
        setAllChapterReward(res?.data?.data?.chapterRewardDetails || []);
        setTotalPage(res?.data?.data.totalCount || 0);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching pending event list:", error);
      });
  };
  //page Click for chapterReward
  const handlePageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };

  const handleEnableDisable = (id) => {
    EnableDistablechapterReward(id).then((res) => {
      if (res?.data?.data?.isDeleted === 2) {
        toast.error(res.data.message);
        fetchData(); // Added semicolon and moved into the block
      } else {
        toast.success(res.data.message);
        fetchData();
      }
    }).catch((error) => {
      console.error("Error enabling/disabling chapter reward:", error);
      toast.error("An error occurred. Please try again.");
    });
  };


  //sliced chapterReward
  const SlicedChapterReward = allChapterReward.slice(0, rowsPerPage); // Adjust slicing

  //calculate pagecount
  const pageCount = Math.ceil(totalPage / itemsPerPage);

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };

  return (
    <div>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Chapter Rewards</h2>
        </div>
      </div>

      <Container maxWidth={'xxl'} className='p-md-5 p-3 overallPadding'>
        <div className="text-end mb-0">
          <Link
            to={memberScope === 'PORTAL_ADMIN' ? '/assistantAdmin/add-edit-chapter-rewards' : '/admin/add-edit-chapter-rewards'}
          >
            <Button
              variant="contained"
              className="menus-color"
              type="submit"
            >
              Add Chapter Reward
            </Button>
          </Link>
        </div>
        {/* </Container> */}
        {loading ? (
          <Spinner />
        ) : (
          <Box className="mb-5 mt-4 p-0">
            <Paper sx={{ width: "100%", mb: 5 }}>
              <TableContainer>
                <Table aria-labelledby="tableTitle">
                  <EnhancedCategoryTableHead />
                  <TableBody>
                    {allChapterReward.length > 0 ? (
                      allChapterReward.map((chapterReward, index) => (
                        <TableRow
                          hover
                          key={chapterReward._id}
                          sx={{
                            cursor: "pointer",
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "white",
                          }}
                        >
                          <TableCell align="center">
                            <img src={chapterReward?.uploadImage} alt={chapterReward._id} />
                          </TableCell>
                          <TableCell
                            align="center" >
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              gap="8px"
                              flexWrap="wrap"
                            >
                              {!(chapterReward.isDeleted === 2) && (
                                <Tooltip title="Edit" placement="top">
                                  <IconButton aria-label="EditIcon">
                                    <Link
                                      to={memberScope === 'PORTAL_ADMIN' ? `/assistantAdmin/add-edit-chapter-reward/${chapterReward._id}` :
                                        `/admin/add-edit-chapter-reward/${chapterReward._id}`}
                                    >
                                      <EditIcon style={{ color: "green" }} />
                                    </Link>
                                  </IconButton>
                                </Tooltip>
                              )}
                              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                {chapterReward?.isDeleted === 0 ? (<>
                                  <Tooltip title="Enable" placement="top">
                                    <IconButton
                                      aria-label="enable"
                                      onClick={() => {
                                        handleEnableDisable(chapterReward._id);
                                      }}
                                    >
                                      <LockOpenIcon style={{ color: "green" }} />
                                    </IconButton>
                                  </Tooltip>
                                </>

                                ) : <Tooltip title="Disable" placement="top">
                                  <IconButton
                                    aria-label="disable"
                                    onClick={() => {
                                      handleEnableDisable(chapterReward._id);
                                    }}
                                  >
                                    <LockIcon style={{ color: "red" }} />
                                  </IconButton>
                                </Tooltip>}
                                {/* {!(chapterReward.isDeleted === 2) &&
                                 <Tooltip title="Delete" placement="top">
                                 <IconButton
                                   aria-label="delete"
                                 onClick={() => handleOpen(chapterReward._id)}
                                 >
                                   <DeleteIcon style={{ color: "red" }} />
                                 </IconButton>
                               </Tooltip>
                                } */}

                              </div>
                            </Box>
                            {/* <Modal
                              open={openModal}
                              onClose={handleClose}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                            >
                              <Box
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  width: 400,
                                  backgroundColor: "white",
                                  boxShadow: 24,
                                  padding: "20px",
                                  outline: "none",
                                }}
                                className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                              >

                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                                    Confirmation
                                  </Typography>
                                  <IconButton onClick={handleClose} aria-label="Close">
                                    <CloseIcon />
                                  </IconButton>
                                </div>
                                <Box display="flex" justifyContent="center" width="100%">
                                  <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                                </Box>
                                <Typography
                                  id="modal-modal-title"
                                  style={{ color: "#611f1e" }}
                                  variant="h6"
                                  component="h2"
                                >
                                  Are You Surely Want to Delete this Chapter Rewards?
                                </Typography>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                  <Button
                                    variant="outlined"
                                    style={{

                                      color: "#dc3545",
                                      border: "1px solid #dc3545",
                                      padding: "5px 15px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={handleClose}
                                  >
                                    No
                                  </Button>
                                  <Button
                                    className="mx-2"
                                    variant="contained"
                                    style={{
                                      backgroundColor: "#2e7d32",
                                      color: "white",
                                      padding: "5px 15px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => handleDelete()}
                                  >
                                    Yes
                                  </Button>
                                </div>
                              </Box>
                            </Modal> */}
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <>
                        <TableRow>
                          <TableCell colSpan={5}>
                            <p className="text-black text-center">
                              Will Be Added Shortly
                            </p>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

            </Paper>
            {SlicedChapterReward.length > 0 ? (

              <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                <div className="mb-2 mb-md-0">
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      min={1}
                      placeholder="Page no."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    <div className="goPage cursor-pointer" onClick={handlePageChange}>
                      <h5 className="p-2 m-0">Go</h5>
                    </div>
                  </div>
                  {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                </div>

                {/* Pagination in the Center */}
                <div className="my-3 my-md-0">
                  <ReactPaginate
                    pageCount={pageCount} // Calculate total pages
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    disabledClassName={"disablebtn"}
                    forcePage={page}
                    previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                    nextLabel={
                      pageCount > 1 && page + 1 !== pageCount ? "Next" : null
                    }
                  />
                </div>
                <div className="mb-2 mb-md-0">
                  <FormControl variant="outlined">
                    <InputLabel></InputLabel>
                    <Select
                      className="itemsperpage"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const value = e.target.value;
                        setItemsPerPage(value);
                        setError('');
                        setSearchTerm('');
                        setPage(0);
                      }}
                      MenuProps={{
                        MenuListProps: {
                          sx: {
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                      }}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>

                  </FormControl>
                </div>
              </div>
            ) : (
              <></>
            )}
          </Box>

        )}
      </Container>
    </div>
  );
}

export default ChapterRewardTable;


